import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { getFeatureLabels } from "../../../helpers";

type FeatureLabelsProps = {
    product: Product<ProductFieldSet.Full>;
};

const FeatureLabels = ({ product }: FeatureLabelsProps) => {
    const { t } = useGranite();

    const featureLabels = getFeatureLabels(product).filter((label) =>
        isDefined(label.imageUrl)
    );

    return (
        <section className={cn("tw:mb-4 tw:flex tw:gap-2")}>
            {featureLabels.map((label, index) => (
                <img
                    key={`label-${index}`}
                    className={cn(
                        "tw:border tw:border-border tw:rounded tw:p-1 tw:bg-transparent tw:w-13.75 tw:h-13.75 tw:object-cover"
                    )}
                    src={label.imageUrl}
                    alt={label.altText ? t(label.altText) : ""}
                    width={55}
                    height={55}
                />
            ))}
        </section>
    );
};

export { FeatureLabels };
